import type React from "react";
import { Dimensions, Platform, StyleSheet, Text, View } from "react-native";
import IconBottomButton from "../../components/IconBottomButton";
import ItemsFlatList from "../../components/ItemsFlatList";
import cColors from "../../styles/componentColors";

const { width } = Dimensions.get("window");

interface YesterdayTasksPageProps {
  navigation: any;
  setTaskIds: (taskIds: string[]) => void;
  scrollRef: any;
  modalRect: any;
  pageIndex: number;
}

const YesterdayTasksPage: React.FC<YesterdayTasksPageProps> = ({
  navigation,
  setTaskIds,
  scrollRef,
  modalRect,
  pageIndex,
}) => {
  return (
    <View style={styles.page}>
      <View style={styles.headerContainer}>
        <Text style={styles.header}>Move incomplete tasks to today</Text>
      </View>
      <ItemsFlatList
        listType="JustYesterdayIncomplete"
        navigation={navigation}
        extraSpaceAtEnd
        setTaskIds={setTaskIds}
        paddingInCell
        hideArrowButton
      />
      <IconBottomButton
        side="right"
        singleTap={() => {
          scrollRef.current.scrollTo({
            x: (modalRect ? modalRect.width : width) * pageIndex,
            animation: true,
          });
        }}
        text="➡️"
        isLandscape={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    paddingTop: 0,
    paddingBottom: 12,
    fontSize: 24,
    color: cColors.HEADER_TEXT_COLOR,
  },
  page: {
    backgroundColor: cColors.PAGE_BG_COLOR,
    flex: 1,
    width: Platform.OS === "web" ? "100%" : width,
    paddingTop: 0,
  },
  headerContainer: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 14,
  },
});

export default YesterdayTasksPage;
